import axios from "axios";
import urls from "../urls";

let userData =
  JSON.parse(localStorage.getItem("userinfo")) ||
  JSON.parse(sessionStorage.getItem("userinfo"));

const {
  GET_PINCODE_SERVICEABILITY,
  GET_PINCODE_SERVICEABILITY_DETAIL,
  BULK_UPLOAD_PINCODE_SERVICEABILITY,
  CREATE_PINCODE_SERVICEABILITY,
  UPDATE_PINCODE_SERVICEABILITY,
  TOGGLE_PINCODE_SERVICE,
  TOGGLE_PINCODE_ACTIVE,
  VALIDATE_PINCODE_SERVICEABILITY,
  GET_VAYUQUICK_SERVICEABILITY,
  CREATE_VAYUQUICK_SERVICEABILITY,
  UPDATE_VAYUQUICK_SERVICEABILITY,
  UPDATE_VAYUQUICK_SERVICEABILITY_ACTIVE,
  GET_PINCODE_AREAS,
  GET_HYPERLOCAL_STATES,
  GET_HYPERLOCAL_CITIES_BY_STATE,
  GET_HYPERLOCAL_ZONES,
  UPDATE_HYPERLOCAL_ZONES,
  CREATE_HYPERLOCAL_ZONES,
  GET_PINCODE_AREA_MASTER,
  EXPORT_PINCODE_SERVICEABILITY,
} = urls;

// Get pincode serviceability list with pagination and filters
export const getPincodeServiceability = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    search = "",
    business_line = "ecomm",
    pincode = "",
    state = "",
    city = "",
    dp_id = "",
    service_type = "",
    is_active = "",
    // Courier-specific filters
    zone = "",
    state_code = "",
    district_ip = "",
    pincode_type = "",
    serviceability_type = "",
    new_city = "",
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    business_line: business_line,
  });

  // Add optional filters
  if (search) queryParams.append("search", search);
  if (pincode) queryParams.append("pincode", pincode);
  if (state) queryParams.append("state", state);
  if (city) queryParams.append("city", city);
  if (dp_id) queryParams.append("dp_id", dp_id);
  if (service_type) queryParams.append("service_type", service_type);
  if (is_active !== "") queryParams.append("is_active", is_active);
  // Courier-specific filters
  if (zone) queryParams.append("zone", zone);
  if (state_code) queryParams.append("state_code", state_code);
  if (district_ip) queryParams.append("district_ip", district_ip);
  if (pincode_type) queryParams.append("pincode_type", pincode_type);
  if (serviceability_type) queryParams.append("serviceability_type", serviceability_type);
  if (new_city) queryParams.append("new_city", new_city);

  const response = await axios.get(`${GET_PINCODE_SERVICEABILITY}?${queryParams}`);
  return response.data;
};

// Export pincode serviceability CSV
export const exportPincodeServiceability = async (params = {}) => {
  const {
    business_line = "courier",
    search = "",
    pincode = "",
    state = "",
    city = "",
    dp_id = "",
    service_type = "",
    is_active = "",
    zone = "",
    state_code = "",
    district_ip = "",
    pincode_type = "",
    serviceability_type = "",
    new_city = "",
  } = params;

  const queryParams = new URLSearchParams({
    business_line: business_line,
  });

  if (search) queryParams.append("search", search);
  if (pincode) queryParams.append("pincode", pincode);
  if (state) queryParams.append("state", state);
  if (city) queryParams.append("city", city);
  if (dp_id) queryParams.append("dp_id", dp_id);
  if (service_type) queryParams.append("service_type", service_type);
  if (is_active !== "") queryParams.append("is_active", is_active);
  if (zone) queryParams.append("zone", zone);
  if (state_code) queryParams.append("state_code", state_code);
  if (district_ip) queryParams.append("district_ip", district_ip);
  if (pincode_type) queryParams.append("pincode_type", pincode_type);
  if (serviceability_type) queryParams.append("serviceability_type", serviceability_type);
  if (new_city) queryParams.append("new_city", new_city);

  const response = await axios.get(`${EXPORT_PINCODE_SERVICEABILITY}?${queryParams}`, {
    responseType: "arraybuffer",
    headers: {
      Authorization: "Bearer " + userData?.accessToken,
    },
  });
  return response;
};

// Get specific pincode serviceability details
export const getPincodeServiceabilityDetail = async (pincode) => {
  const response = await axios.get(`${GET_PINCODE_SERVICEABILITY_DETAIL}/${pincode}`);
  return response.data;
};

// Bulk upload pincode serviceability via Excel/CSV
export const bulkUploadPincodeServiceability = async (file) => {
  try {
    // Validate file before upload
    if (!file) {
      throw new Error("No file provided");
    }


    // Check file type
    const allowedTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ];
    const allowedExtensions = [".csv", ".xls", ".xlsx"];
    
    const hasValidType = allowedTypes.includes(file.type);
    const hasValidExtension = allowedExtensions.some(ext => 
      file.name.toLowerCase().endsWith(ext)
    );

    if (!hasValidType && !hasValidExtension) {
      throw new Error("Invalid file type. Please upload CSV or Excel files only.");
    }

    const formData = new FormData();
    formData.append("file", file);


    const response = await axios.post(BULK_UPLOAD_PINCODE_SERVICEABILITY, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 60000, // 60 second timeout for large files
    });

    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      // Server error
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      // Network error
      throw new Error("Network error: Unable to reach server");
    } else {
      // Other error (validation, etc.)
      throw error;
    }
  }
};

// Create new pincode serviceability
export const createPincodeServiceability = async (data) => {
  const response = await axios.post(CREATE_PINCODE_SERVICEABILITY, data);
  return response.data;
};

// Update pincode serviceability
export const updatePincodeServiceability = async (pincode, data) => {
  const response = await axios.put(`${UPDATE_PINCODE_SERVICEABILITY}/${pincode}`, data);
  return response.data;
};

// Search pincodes for dropdown (using the same API with search filter)
export const searchPincodes = async (searchTerm) => {
  const response = await axios.get(`${GET_PINCODE_SERVICEABILITY}?search=${searchTerm}&limit=50`);
  return response.data.data || [];
};

// Toggle pincode service status
export const togglePincodeService = async (toggleData) => {
  try {
    // toggleData should be an array of objects: [{ pincode: number, service_id: number }]
    const response = await axios.patch(TOGGLE_PINCODE_SERVICE, toggleData);
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Toggle pincode active/inactive status
export const togglePincodeActive = async (pincodes, isActive, businessLine) => {
  try {
    // API expects: { pincodes: [number], isActive: boolean, businessLine: string }
    const response = await axios.patch(TOGGLE_PINCODE_ACTIVE, {
      pincodes: Array.isArray(pincodes) ? pincodes : [pincodes],
      isActive,
      businessLine,
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Validate pincode serviceability
export const validateVayuQuickPincodeServiceability = async (payload) => {
  try {
    const response = await axios.post(VALIDATE_PINCODE_SERVICEABILITY, payload, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return { response: response, status: true };
  } catch (error) {
    return { response: error.response, status: false };
  }
};

// Create VayuQuick pincode serviceability
export const createVayuQuickPincodeServiceability = async (payload) => {
  try {
    const response = await axios.post(CREATE_VAYUQUICK_SERVICEABILITY, payload, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return { response: response, status: true };
  } catch (error) {
    return { response: error.response, status: false };
  }
};

// Get VayuQuick serviceability list
export const getVayuQuickServiceability = async (page, limit) => {
  try {
    const response = await axios.get(
      `${GET_VAYUQUICK_SERVICEABILITY}?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: "Bearer " + userData?.accessToken,
        },
      }
    );
    return { response: response, status: true };
  } catch (error) {
    return { response: error.response, status: false };
  }
};

// Update VayuQuick serviceability booking only status
export const updateVayuQuickServiceability = async (payload) => {
  try {
    const response = await axios.patch(UPDATE_VAYUQUICK_SERVICEABILITY, payload, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return { response: response, status: true };
  } catch (error) {
    return { response: error.response, status: false };
  }
};

// Update VayuQuick serviceability active status
export const updateVayuQuickServiceabilityActive = async (payload) => {
  try {
    const response = await axios.patch(
      UPDATE_VAYUQUICK_SERVICEABILITY_ACTIVE,
      payload,
      {
        headers: {
          Authorization: "Bearer " + userData?.accessToken,
        },
      }
    );
    return { response: response, status: true };
  } catch (error) {
    return { response: error.response, status: false };
  }
};

// Get pincode areas with pagination and filters
export const getPincodeAreas = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    pincode = "",
    area_name = "",
    area_type = "",
    transit_days_for_delivery = "",
    pincode_type = "",
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });

  // Add optional filters
  if (pincode) queryParams.append("pincode", pincode.toString());
  if (area_name) queryParams.append("area_name", area_name);
  if (area_type) queryParams.append("area_type", area_type);
  if (transit_days_for_delivery) {
    queryParams.append("transit_days_for_delivery", transit_days_for_delivery.toString());
  }
  if (pincode_type) queryParams.append("pincode_type", pincode_type);

  try {
    const response = await axios.get(`${GET_PINCODE_AREAS}?${queryParams}`, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Get all states for hyperlocal
export const getAllStates = async () => {
  try {
    const response = await axios.get(GET_HYPERLOCAL_STATES, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Get cities by state for hyperlocal
export const getCitiesByState = async (state) => {
  try {
    const response = await axios.get(`${GET_HYPERLOCAL_CITIES_BY_STATE}?state=${state}`, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Get hyperlocal zones by city
export const getHyperlocalZones = async (city) => {
  try {
    const response = await axios.get(`${GET_HYPERLOCAL_ZONES}?city=${city}`, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Update hyperlocal zone
export const updateHyperlocalZone = async (zoneData) => {
  try {
    const response = await axios.put(UPDATE_HYPERLOCAL_ZONES, {
      data: zoneData,
    }, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Get pincode area master for hyperlocal
export const getPincodeAreaMaster = async (state, city) => {
  try {
    const queryParams = new URLSearchParams({
      state: state,
      city: city,
    });
    const response = await axios.get(`${GET_PINCODE_AREA_MASTER}?${queryParams}`, {
      headers: {
        Authorization: "Bearer " + userData?.accessToken,
      },
    });
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

// Create hyperlocal zone
export const createHyperlocalZone = async (zoneData, city) => {
  try {
    const queryParams = new URLSearchParams({
      city: city,
    });
    const response = await axios.post(
      `${CREATE_HYPERLOCAL_ZONES}?${queryParams}`,
      {
        data: {
          name: zoneData.name,
          city: zoneData.city,
          state: zoneData.state,
          serviceablePincodes: zoneData.serviceablePincodes,
          isActive: true,
          orderProcessType: "NORMAL",
          acceptNormalOrder: false,
          acceptSubscriptionOrder: false,
        },
        uniqueFieldName: "name",
      },
      {
        headers: {
          Authorization: "Bearer " + userData?.accessToken,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    // Re-throw with more context
    if (error.response) {
      const serverError = new Error(
        error.response.data?.message || 
        `Server error: ${error.response.status}`
      );
      serverError.response = error.response;
      throw serverError;
    } else if (error.request) {
      throw new Error("Network error: Unable to reach server");
    } else {
      throw error;
    }
  }
};

export default {
  getPincodeServiceability,
  getPincodeServiceabilityDetail,
  bulkUploadPincodeServiceability,
  createPincodeServiceability,
  updatePincodeServiceability,
  searchPincodes,
  togglePincodeService,
  togglePincodeActive,
  validateVayuQuickPincodeServiceability,
  createVayuQuickPincodeServiceability,
  getVayuQuickServiceability,
  updateVayuQuickServiceability,
  updateVayuQuickServiceabilityActive,
  getPincodeAreas,
  getAllStates,
  getCitiesByState,
  getHyperlocalZones,
  updateHyperlocalZone,
  createHyperlocalZone,
  getPincodeAreaMaster,
  exportPincodeServiceability,
};
